import { of, tap, switchMap, combineLatest, catchError } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './view.js';
import { dayOfWeek, formatDateHuman, formatDateApi } from './date.js';
import { dishesById$, getPlan, formatApiErrorMessage } from './api.js';
import { showErrorBanner } from './dom.js';

export function createWeekPlanView(startDate) {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('week-plan-view');
            let dayElements = renderDays(root.querySelector('.dish-days-container'), startDate);
            wireDateJumpButton('.date-navigation-bar .goto-past', -3);
            wireDateJumpButton('.date-navigation-bar .goto-future', 3);
            root.querySelector('.date-navigation-bar .goto-today').addEventListener(
                'click',
                () => {
                    window.location.hash = '';
                },
                false
            );
            replaceViewContainer(root);
            return combineLatest([dishesById$, getPlan(startDate)]).pipe(
                tap(([dishesById, plan]) => {
                    for (let day of Object.keys(dayElements)) {
                        let dayContainer = dayElements[day];
                        let plannedDishes = plan[day] || [];
                        populateDishesIntoDay(dayContainer, day, plannedDishes, dishesById);
                    }
                }),
                catchError((err) => {
                    showErrorBanner(root, formatApiErrorMessage(err));
                    throw err;
                })
            );

            function wireDateJumpButton(selector, deltaDays) {
                let btn = root.querySelector(selector);
                btn.addEventListener(
                    'click',
                    () => {
                        let targetDate = new Date(startDate);
                        targetDate.setDate(targetDate.getDate() + deltaDays);
                        window.location.hash = `#/plan/${formatDateApi(targetDate)}`;
                    },
                    false
                );
            }
        })
    );
}

function renderDays(container, startDate, days = 7) {
    let todayKey = formatDateApi(new Date());
    let dayElements = {};
    for (let i = 0; i < days; ++i) {
        let day = new Date(startDate);
        day.setDate(day.getDate() + i);
        let dayKey = formatDateApi(day);
        let dayEl = renderTemplate('week-plan-day-view');
        dayEl.querySelector('.day-of-week').textContent = dayOfWeek[day.getDay()];
        dayEl.querySelector('.date').textContent = formatDateHuman(day);
        if (todayKey === dayKey) {
            dayEl.classList.add('today');
        }
        container.appendChild(dayEl);
        dayElements[dayKey] = dayEl;
    }
    return dayElements;
}

function populateDishesIntoDay(dayContainer, day, plannedDishes, dishesById) {
    let dishesContainer = dayContainer.querySelector('.dishes');
    dishesContainer.innerHTML = '';
    for (let pd of plannedDishes) {
        let dish = dishesById.get(pd.dish_id);
        let pdEl = renderTemplate('week-plan-dish-view');
        pdEl.setAttribute('data-planned-dish-id', '' + pd.id);
        pdEl.querySelector('.dish-title').textContent = dish.title;
        dishesContainer.appendChild(pdEl);
    }
    dayContainer.querySelector('.add-planned-dish').addEventListener(
        'click',
        (event) => {
            window.location.href = `#/add-dish/${day}`;
        },
        false
    );
}
